
import { useStore } from "../../state/state.ts";
import { GEBAEUDE_TYP_OPTIONS } from "../../state/types.ts";
import ModalGebaeudetyp from "../../modals/modal_gebaeude_typ.tsx";
import { inputOnKeyUp } from "../../functions.ts";

export default function MeasureWidgetBase() {
  const push_modal = useStore((state) => state.push_modal_closeable);
  let baujahr = useStore((state)=>state.baujahr) ?? "";
  let plz = useStore((state)=>state.postleitzahl) ?? "";
  let region =  useStore((state)=>state.region_name) || plz;

  let _gebaeude_typ = useStore((state)=> state.gebaeude_typ);
  let gebaeude_typ = GEBAEUDE_TYP_OPTIONS.find((x)=> x.value == _gebaeude_typ)?.label ?? "Keine Auswahl";

  return  <div 
    tabIndex={0}
    role="button"
    className='measure'
    aria-label="Basisdaten"
    aria-aria-description={
      "Gebäudetyp:" + (gebaeude_typ || "nicht definiert")+" Baujahr"+(baujahr || "nicht definiert")
    }
    onClick={()=>{
      push_modal(<ModalGebaeudetyp/>)
    }}
     onKeyUp={(event)=>inputOnKeyUp(event, ()=>{
      push_modal(<ModalGebaeudetyp/>)
      setTimeout(() => {
        document.querySelector(".modal [tabindex]").focus();
      }, 100); 
    })}
    >
  <div aria-hidden className='measure__label'>Basisdaten</div>
  <div aria-hidden className='measure__infos' style={{flexDirection: "column", alignItems: "flex-start"}}>
    <div aria-hidden className={'measure__info-now  measure__info-now--single'}>{gebaeude_typ} {baujahr && "von"} {baujahr}</div>
    <div aria-hidden className={'measure__info-now  measure__info-now--single'}>in {region}</div>
  </div>
 </div>;
}
